import { z } from "zod";

export const generateInvoiceSchema = z.object({
  insurer_id: z.string().trim().min(1, "Insurer is required"),
  period_type: z.string().trim().min(1, "Period type is required"),
  period: z.string().trim().min(1, "Period is required"),
});

export type GenerateInvoiceSchemaValues = z.infer<typeof generateInvoiceSchema>;
